import { Message } from "../../../domain/model/Auth";
import {
  Game,
  GiveRatingRequestModel,
  UpdateGameRequestModel,
} from "../../../domain/model/Game";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { GameRepository } from "./GameRepository";

export class GameRepositoryImpl implements GameRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  createGame(): Promise<Response<Game>> {
    return this.apiService.createGame();
  }
  updateGame(model: UpdateGameRequestModel): Promise<Response<Message>> {
    return this.apiService.updateGame(model);
  }
  giveRating(
    gameId: string,
    giveRatingModel: GiveRatingRequestModel,
  ): Promise<Response<Message>> {
    return this.apiService.giveRatingToGame(gameId, giveRatingModel);
  }
}
